import * as React from 'react';
import styled from 'styled-components';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import { Theme } from '@material-ui/core';
import { DSButtonProps, DSButton } from '../DSButton';

const TextButtonIcon = styled(ArrowForwardIos)`
    height: 0.7em;
    margin-left: 4px;
`;

type GetPaddingProps = { size?: DSButtonProps['size']; theme: Theme };
const getPadding = ({ size, theme }: GetPaddingProps): string => {
    if (size === 'small') {
        return `${theme.spacing(0)}px`;
    } else if (size === 'large') {
        return `${theme.spacing(2)}px`;
    } else {
        return `${theme.spacing(1)}px`;
    }
};
const StyledTextButton = styled(DSButton)<{ $noPadding?: boolean }>`
    padding: ${props => (props.$noPadding ? '0px' : getPadding(props))};
`;

export type DSTextButtonProps = Omit<DSButtonProps, 'variant'> & {
    noPadding?: boolean;
    hideArrow?: boolean;
};
export const DSTextButton: React.FC<DSTextButtonProps> = ({ children, hideArrow, noPadding, ...rest }) => (
    <StyledTextButton {...rest} $noPadding={noPadding} variant="text">
        {children}
        {!hideArrow && <TextButtonIcon />}
    </StyledTextButton>
);
DSTextButton.displayName = 'DSTextButton';
